import {
    getCalibratedObservations,
    getFilteredObservations,
    type EBirdMyDataSchema,
    type EBirdSightingsCalibrationResult
} from "ebird-mydata-reader";

export const getYearSpeciesKey = (observation: EBirdMyDataSchema) => {
    return observation.reportAsTaxonomicOrder ??
        observation.canonicalTaxonomicOrder ??
        observation.taxonomicOrder ??
        observation.commonName;
};

export const getObservationYears = (rawData: EBirdMyDataSchema[]) => {
    return Array.from(new Set(rawData
        .map(observation => observation.observedYear ?? Number(observation.date?.slice(0, 4)))
        .filter((year): year is number => Number.isInteger(year))
    ));
};

export const getYearSpeciesObservations = (
    rawData: EBirdMyDataSchema[],
    year: number,
    calibrationResult?: EBirdSightingsCalibrationResult
) => {
    return calibrationResult
        ? getCalibratedObservations(calibrationResult, year)
        : getFilteredObservations(rawData, year);
};

export const getYearSpecies = (
    rawData: EBirdMyDataSchema[],
    year: number,
    calibrationResult?: EBirdSightingsCalibrationResult
) => {
    return new Set(
        getYearSpeciesObservations(rawData, year, calibrationResult)
            .map(getYearSpeciesKey)
            .filter(Boolean)
    );
};
